"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onFindByUserAppAndFunctions = onFindByUserAppAndFunctions;
exports.onFetchJwtTokenSN = onFetchJwtTokenSN;
exports.onFetchUserSession = onFetchUserSession;
exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;
exports.onCommonService = onCommonService;
exports.onFetchUserPersona = onFetchUserPersona;
exports.default = watchListTodos;

var _effects = require("redux-saga/effects");

var _baseLayout = require("./base-layout.constants");

var _baseLayout2 = require("./base-layout.actions");

var service = _interopRequireWildcard(require("./base-layout.service"));

var _baseLayout4 = _interopRequireDefault(require("./base-layout.gateway"));

var _reduxSaga = require("redux-saga");

var _reactToastify = require("react-toastify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onFindByUserAppAndFunctions),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(onFetchJwtTokenSN),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(onFetchUserSession),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(isActionTrackingToBeAcknowledged),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(onCommonService),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(pollActionTrackingToBeAcknowledged),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(onFetchUserPersona),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(watchListTodos);

function onFindByUserAppAndFunctions(action) {
  var result, brandCodes, claims;
  return regeneratorRuntime.wrap(function onFindByUserAppAndFunctions$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(service.findByUserAppAndFunctions, action);

        case 3:
          result = _context.sent;

          if (!result) {
            _context.next = 14;
            break;
          }

          brandCodes = result.brands;

          if (result.userAppFunctions && result.userAppFunctions.cc && result.userAppFunctions.cc.length > 0) {
            claims = result.userAppFunctions.cc;
            claims.forEach(function (c) {
              if (c.k === "PPHSID" && c.v && c.v.length > 0) {
                localStorage.setItem("PPHSID", c.v[0]);
              }
            });
          }

          _context.next = 9;
          return (0, _effects.put)((0, _baseLayout2.findByUserAppAndFunctionsSuccess)(result));

        case 9:
          if (!brandCodes) {
            _context.next = 12;
            break;
          }

          _context.next = 12;
          return (0, _effects.put)((0, _baseLayout2.updateBrands)(brandCodes.brands));

        case 12:
          _context.next = 15;
          break;

        case 14:
          throw new Error("Error in fetching details");

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](0);
          _context.next = 21;
          return (0, _effects.put)((0, _baseLayout2.findByUserAppAndFunctionsError)(false));

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 17]]);
}

function onFetchJwtTokenSN(action) {
  var jwtToken, data;
  return regeneratorRuntime.wrap(function onFetchJwtTokenSN$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(service.getJwtTokenSN, action.userId, action.appName);

        case 3:
          jwtToken = _context2.sent;
          console.log("Action", action);
          data = {
            jwtToken: jwtToken,
            decoded: action.decoded,
            appName: action.appName
          };
          _context2.next = 8;
          return (0, _effects.put)((0, _baseLayout2.setJwttokenSN)(data));

        case 8:
          _context2.next = 14;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 14;
          return (0, _effects.put)((0, _baseLayout2.setJwttokenSN)(null));

        case 14:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 10]]);
}

function onFetchUserSession(action) {
  var userSession;
  return regeneratorRuntime.wrap(function onFetchUserSession$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(service.getUserSessionService, action.cacheKey);

        case 3:
          userSession = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)((0, _baseLayout2.getUserSessionToken)(userSession));

        case 6:
          _context3.next = 12;
          break;

        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 12;
          return (0, _effects.put)((0, _baseLayout2.getUserSessionToken)(null));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 8]]);
}

function isActionTrackingToBeAcknowledged(action) {
  var response;
  return regeneratorRuntime.wrap(function isActionTrackingToBeAcknowledged$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!true) {
            _context4.next = 30;
            break;
          }

          _context4.next = 3;
          return (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(true));

        case 3:
          _context4.prev = 3;
          _context4.next = 6;
          return (0, _effects.call)(service.isActionTrackingToBeAcknowledged, action.input);

        case 6:
          response = _context4.sent;

          if (!(response && response.pageCount)) {
            _context4.next = 12;
            break;
          }

          _context4.next = 10;
          return (0, _effects.put)((0, _baseLayout2.setNumberOfActionTrackingItemsToBeAcknowledged)(response.pageCount));

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.put)((0, _baseLayout2.setNumberOfActionTrackingItemsToBeAcknowledged)(null));

        case 14:
          _context4.next = 16;
          return (0, _effects.put)((0, _baseLayout2.isActionTrackingToBeAcknowledgedError)(response && response.pageCount) || null);

        case 16:
          _context4.next = 18;
          return (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(false));

        case 18:
          _context4.next = 20;
          return (0, _effects.call)(_reduxSaga.delay, 60000);

        case 20:
          _context4.next = 28;
          break;

        case 22:
          _context4.prev = 22;
          _context4.t0 = _context4["catch"](3);
          _context4.next = 26;
          return (0, _effects.put)((0, _baseLayout2.isActionTrackingToBeAcknowledgedError)(null));

        case 26:
          _context4.next = 28;
          return (0, _effects.put)((0, _baseLayout2.loadingActionTrackingItemsToBeAcknowledged)(false));

        case 28:
          _context4.next = 0;
          break;

        case 30:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[3, 22]]);
}

function onCommonService(action) {
  var output, args, _args5;

  return regeneratorRuntime.wrap(function onCommonService$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(service[action.service], action.args || null);

        case 3:
          output = _context5.sent;
          args = (0, _baseLayout2.commonServiceSuccess)(output);
          args[action.service] = false;
          _context5.next = 8;
          return (0, _effects.put)(args);

        case 8:
          action.callback && action.callback(null, output);
          _context5.next = 18;
          break;

        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _args5 = (0, _baseLayout2.commonServiceError)(_context5.t0);
          _args5.service = action.service;
          _context5.next = 17;
          return (0, _effects.put)(_args5);

        case 17:
          action.callback && action.callback(_context5.t0);

        case 18:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 11]]);
}

function pollActionTrackingToBeAcknowledged(action) {
  return regeneratorRuntime.wrap(function pollActionTrackingToBeAcknowledged$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.race)([(0, _effects.call)(isActionTrackingToBeAcknowledged, action), (0, _effects.take)(_baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function onFetchUserPersona(action) {
  var userPersona;
  return regeneratorRuntime.wrap(function onFetchUserPersona$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(service.getPersonasForUserApp, action.userId, action.appName);

        case 3:
          userPersona = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)((0, _baseLayout2.setPersonaUser)(userPersona));

        case 6:
          _context7.next = 11;
          break;

        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](0);

          _reactToastify.toast.error(_context7.t0.message, {
            position: _reactToastify.toast.POSITION.TOP_RIGHT,
            allowHtml: true,
            autoClose: true
          });

        case 11:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[0, 8]]);
}

function watchListTodos() {
  return regeneratorRuntime.wrap(function watchListTodos$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return [(0, _effects.takeLatest)(_baseLayout.FINDBYUSERAPPANDFUNCTIONS, onFindByUserAppAndFunctions)];

        case 2:
          _context8.next = 4;
          return [(0, _effects.takeLatest)(_baseLayout.GET_PERSONA_FOR_USER, onFetchUserPersona)];

        case 4:
          _context8.next = 6;
          return (0, _effects.takeLatest)(_baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED, pollActionTrackingToBeAcknowledged);

        case 6:
          _context8.next = 8;
          return [(0, _effects.takeLatest)(_baseLayout.FETCH_JWTTOKENSN, onFetchJwtTokenSN)];

        case 8:
          _context8.next = 10;
          return [(0, _effects.takeLatest)(_baseLayout.GET_USER_SESSION, onFetchUserSession)];

        case 10:
          _context8.next = 12;
          return (0, _effects.takeEvery)(_baseLayout.COMMON_SERVICE, onCommonService);

        case 12:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}